const componentMapping = {
  scheduledPayments: {
    component: () => import('@/modules/payments/components/ScheduledPaymentsSidePane.vue'),
    title: 'side_pane.scheduled_payments.title',
    attribute: 'scheduled_payments_eligible',
  },
};

export default componentMapping;
